import {
  FormHub,
  FormDatePicker,
  ErrorDisplay,
  SubmitButton,
  useFormEvents,
  EnumValueDisplay,
  FormSelect,
  Section,
  Feedback,
} from '@lib/common';
import { FormStatus, Reservations } from '@lib/state';
import { Grid, MenuItem } from '@material-ui/core';
import { InvoiceType, reportService, ReportForms } from 'app/state';
import React, { useCallback } from 'react';

interface FormFields {
  startDate: string;
  endDate: string;
  invoiceType: InvoiceType;
}

interface Props {
  customerId: string;
}

export function DownloadInvoiceSummary({ customerId }: Props) {
  const [{ status, error: formError }] = useFormEvents(ReportForms.InvoiceSummary);

  const onSubmit = useCallback(
    (fields: FormFields) => {
      reportService.downloadInvoiceSummary({ customerId, ...fields });
    },
    [customerId]
  );

  return (
    <Section title="Invoice Summary">
      <FormHub<FormFields> onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item md={2} xs={6}>
            <FormDatePicker
              name="startDate"
              label="Start Date"
              fullWidth
              validationOptions={{ required: true }}
              format="MM/dd/yyyy"
              autoOk
            />
          </Grid>
          <Grid item md={2} xs={6}>
            <FormDatePicker
              name="endDate"
              label="End Date"
              fullWidth
              validationOptions={{ required: true }}
              format="MM/dd/yyyy"
              autoOk
            />
          </Grid>
          <Grid item md={2} xs={6}>
            <FormSelect
              name="invoiceType"
              label="Invoice Type"
              fullWidth
              required
              defaultValue={Reservations.InvoiceType.RoomInvoice}
            >
              {Object.keys(InvoiceType).map(t => (
                <MenuItem value={t} key={t}>
                  <EnumValueDisplay value={t} />
                </MenuItem>
              ))}
            </FormSelect>
          </Grid>
          <Grid item md={2} xs={6}></Grid>
          <Grid item md={2} xs={6}>
            <SubmitButton
              variant="contained"
              color="secondary"
              fullWidth
              pending={status === FormStatus.Pending}
              disabled={status === FormStatus.Pending}
            >
              Download
            </SubmitButton>
          </Grid>

          <Grid item>
            <Feedback show={status === FormStatus.Success} severity="success">
              Invoice Summary Report Requested
            </Feedback>
            <ErrorDisplay error={formError} />
          </Grid>
        </Grid>
      </FormHub>
    </Section>
  );
}
